export const getLengthError = (value = '', label, min, max) => {
    const trimmed = value.trim();
    if (!trimmed) {
        return `${label} is required`;
    }
    if (trimmed.length < min) {
        return `${label} must be at least ${min} characters`;
    }
    if (trimmed.length > max) {
        return `${label} must be ${max} characters or less`;
    }
    return null;
}

export const findDuplicateIds = (items, getValue) => {
    const seen = {};
    return items.reduce((duplicates, item) => {
        const value = getValue(item).trim().toLowerCase();
        if (value && seen[value]) {
            return [...duplicates, item.id];
        }
        seen[value] = true;
        return duplicates;
    }, []);
}

export const hasErrors = (errors) => Object.keys(errors).length > 0;
